import React from "react";
import Card from "components/card";
import ProductivityEmployeeCard from "./ProductivityEmployeeCard"

const EmployeeListPanel = ({ employees, selectedEmployee, onSelect }) => {

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-slate-200 shadow-lg overflow-hidden h-full">
            <div className="px-6 pt-6 pb-6 bg-gradient-to-br from-cyan-50 to-blue-50 border-b rounded-t-xl grid gap-1.5">
                <h4 className="text-[20px] font-medium">
                    Team Members
                </h4>
                <p className="text-[15px] font-normal text-slate-700">
                    {employees.length} members
                </p>
            </div>
            <div className="p-4 pb-6">
                <div className="space-y-3 overflow-y-auto">
                    {employees.map((emp) => (
                        <ProductivityEmployeeCard
                            key={emp?.employee_id}
                            initials={emp?.initials}
                            name={emp.name}
                            role={emp?.role}
                            weekly_average={emp?.details?.metrics?.weekly_average}
                            department={emp?.details?.department}
                            productivity_score={emp?.details?.productivity_score}
                            status={emp?.details?.status}
                            selected={selectedEmployee?.employee_id === emp.employee_id}
                            onClick={() => onSelect(emp)}
                        />
                    ))}
                </div>
            </div>
        </Card>
    );
};

export default EmployeeListPanel;